import {
  Component,
  NgZone,
  OnInit,
  OnDestroy,
  ViewChild,
} from "@angular/core";
import { Router, NavigationEnd } from "@angular/router";
import { Subscription } from "rxjs";
// import 'rxjs/add/operator/filter';
import { filter } from "rxjs/operators";

// import { TranslateService } from '@ngx-translate/core';

import {
  PerfectScrollbarConfigInterface,
  PerfectScrollbarDirective
} from "ngx-perfect-scrollbar";
import { fadeAnimation } from "src/app/animations/fade.animation";
import { HoldingService } from "src/app/services/http/business/holding/holding.service";
import { Title } from "@angular/platform-browser";
import { environment } from "src/environments/environment";

const SMALL_WIDTH_BREAKPOINT = 960;

@Component({
  selector: "app-main-layout",
  templateUrl: "./main-layout.component.html",
  styleUrls: ["./main-layout.component.css"],
  animations: [fadeAnimation]
})
export class MainLayoutComponent implements OnInit, OnDestroy {
  isOwner: boolean;
  private _router: Subscription;

  mediaMatcher: MediaQueryList = matchMedia(
    `(max-width: ${SMALL_WIDTH_BREAKPOINT}px)`
  );
  url: string;
  sidePanelOpened;
  options = {
    collapsed: false,
    compact: false,
    boxed: false,
    dark: false,
    dir: "rtl"
  };

  @ViewChild("sidemenu") sidemenu;
  @ViewChild(PerfectScrollbarDirective)
  directiveScroll: PerfectScrollbarDirective;

  public config: PerfectScrollbarConfigInterface = {};

  constructor(
    zone: NgZone,
    private router: Router,
    private titleService: Title,
    //private activatedRoute: ActivatedRoute,
    private holdingService: HoldingService
  ) {
    this.mediaMatcher.addListener(mql =>
      zone.run(() => {
        this.mediaMatcher = mql;
      })
    );
  }
  ngOnInit(): void {


    this.checkOwner();
    this.url = this.router.url;
    this._router = this.router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .subscribe((event: NavigationEnd) => {
        document.querySelector(
          ".app-inner > .mat-drawer-content > div"
        ).scrollTop = 0;
        this.url = event.url;
        this.runOnRouteChange();
      });
  }

  checkOwner() {
    this.holdingService.checkOwnerHolding().subscribe(res => {
      this.isOwner = res.IsOwner;
    });
  }

  ngOnDestroy(): void {
    this._router.unsubscribe();
  }

  runOnRouteChange(): void {
    this.setTitle();
    // this.activatedRoute.data.subscribe(d => {
    //   console.log(d.breadcrumb)
    // })

    if (this.isOver()) {
      this.sidemenu.close();
    }

    this.updatePS();
  }

  public setTitle() {
    this.titleService.setTitle(environment.siteTitle);
  }

  receiveOptions($event): void {
    this.options = $event;
  }

  isOver(): boolean {
    if (
      this.url === "/apps/messages" ||
      this.url === "/apps/calendar" ||
      this.url === "/apps/media" ||
      this.url === "/maps/leaflet" ||
      this.url === "/taskboard"
    ) {
      return true;
    } else {
      return this.mediaMatcher.matches;
    }
  }

  menuMouseOver(): void {
    if (this.mediaMatcher.matches && this.options.collapsed) {
      this.sidemenu.mode = "over";
    }
  }

  menuMouseOut(): void {
    if (this.mediaMatcher.matches && this.options.collapsed) {
      this.sidemenu.mode = "side";
    }
  }

  updatePS(): void {
    if (!this.mediaMatcher.matches && !this.options.compact) {
      setTimeout(() => {
        this.directiveScroll.update();
      }, 350);
    }
  }

  public getRouterOutletState(outlet) {
    return outlet.isActivated ? outlet.activatedRoute : "";
  }
}
